module.exports = __webpack_public_path__ + "img/icon-private-post.507f442a.png";